// Official table tennis rules, condensed for the kiosk Help overlay (DESIGN.md section 9.1,
// screen 3 note "user feedback item 3", 2026-08-30). Source: ITTF Laws of Table Tennis, English,
// trimmed to what a walk-up player actually needs at the table — not a reproduction of the full
// rulebook. Kept as short, independent bullets (no numbering implying rule-number authority) so
// HelpOverlay.vue can render them as a scannable list rather than a wall of text.
//
// 2026-08-31 (round-3 feedback item 7d): es-ES is the kiosk's DEFAULT language (src/i18n.ts), so
// this content is now locale-keyed. `es` is a faithful translation of `en` (same substance, not
// re-derived rules) — keep the two in sync when editing either.
import type { Locale } from './i18n'

export const TABLE_TENNIS_RULES: Record<Locale, string[]> = {
  en: [
    'Games are played to 11 points; you must win by at least 2 clear points.',
    'Each player serves 2 points in a row. The serve alternates every 2 points — except from 10–10 (deuce), where it alternates every single point.',
    'A match is a fixed best-of number of games (1, 3, 5, or 7) — first to win the majority of games wins the match.',
    'To serve: toss the ball near-vertically from an open, flat palm, then strike it from behind your end of the table.',
    'On the serve, the ball must bounce once on the server’s side, clear the net, then bounce once on the receiver’s side.',
    'A serve that clips the net but still lands correctly is a "let" — no point is scored, the serve is simply replayed.',
    'Rally scoring: every point played is won by someone, whether or not you served it.',
    'Players switch ends after every game, and again mid-decider as soon as either player reaches 5 points.',
  ],
  es: [
    'Los juegos se disputan a 11 puntos; hay que ganar con una ventaja mínima de 2 puntos.',
    'Cada jugador saca 2 puntos seguidos. El saque cambia cada 2 puntos — excepto a partir de 10-10 (deuce), donde cambia en cada punto.',
    'Un partido se juega al mejor de un número fijo de juegos (1, 3, 5 o 7) — gana el partido quien primero sume la mayoría de los juegos.',
    'Para sacar: lanza la bola casi verticalmente desde la palma abierta y plana, y golpéala desde detrás de tu lado de la mesa.',
    'En el saque, la bola debe botar una vez en el lado de quien saca, pasar la red, y botar una vez en el lado de quien recibe.',
    'Un saque que roza la red pero entra correctamente es un "let" — no se anota el punto, simplemente se repite el saque.',
    'Tanteo directo: cada punto disputado lo gana alguien, hayas sacado tú o no.',
    'Los jugadores cambian de lado después de cada juego, y de nuevo a mitad del juego decisivo en cuanto alguien llega a 5 puntos.',
  ],
}
